module.exports = __webpack_public_path__ + "img/ex-timeline_lg.56f27044.png";